var exports = {
  "kL": "container__MIdVCg",
  "Kk": "icon__1THULI",
  "Qq": "text__R_1e8E",
};

module.exports = exports;
